// v050-u6a (B-602) — module dédié : la vue par profil est une préférence PERSONNELLE portée
// par l'espace (`X-Workspace-Id`), distincte du mode de navigation et du rôle d'accès.
import { request } from './http'
import type { ProfileId, ProfilePreference, ProfileView } from './types/profile'

export const profilePreferencesApi = {
  /** Vue choisie dans cet espace ; `view = null` si l'utilisateur n'a encore rien choisi. */
  getProfilePreference: (workspaceId: string) =>
    request<ProfilePreference>('/users/me/preferences/profile',
      { headers: { 'X-Workspace-Id': workspaceId } }),
  /** `expectedVersion` fourni : un choix concurrent plus récent est refusé (409 STALE_VERSION). */
  setProfilePreference: (workspaceId: string, input: {
    view: ProfileView
    profiles?: ProfileId[]
    expectedVersion?: number | undefined
  }) =>
    request<ProfilePreference>('/users/me/preferences/profile', {
      method: 'PUT',
      headers: { 'X-Workspace-Id': workspaceId },
      body: JSON.stringify({
        view: input.view,
        profiles: input.profiles ?? [],
        ...(input.expectedVersion != null ? { expectedVersion: input.expectedVersion } : {}),
      }),
    }),
  /** Revenir à la vue SUGGÉRÉE : efface le choix de l'utilisateur dans cet espace (idempotent). */
  resetProfilePreference: (workspaceId: string) =>
    request<void>('/users/me/preferences/profile', { method: 'DELETE', headers: { 'X-Workspace-Id': workspaceId } }),
}
